import cn from 'classnames'
import React from 'react'
import styled from '@emotion/styled'
import { SVGIcon } from 'shared/ui'

import ToggleKbSearchDropdown from './Dropdown'
import WithUpdateSidebar from './WithUpdateSidebar'

const HoverSVGIcon = styled(SVGIcon)`
  color: ${props => props.theme.color.monochrome.mediumDark};
  cursor: pointer;
  height: 20px;

  &:hover,
  &.active {
    color: ${props => props.theme.color.primary.brand};
  }
`

const tooltipConfig = {
  tooltip: 'Show knowledge base toolbar',
  position: 'top',
}

export default function ToggleKbSearchView({
  className,
  toggleKnowledgebaseToolbar,
  hasKnowledgebases,
  isOpen,
  size = 16,
}) {
  return (
    <ToggleKbSearchDropdown
      className={className}
      key="toggle-kb-search"
      onClick={toggleKnowledgebaseToolbar}
      hasKnowledgebases={hasKnowledgebases}
      isOpen={isOpen}
      trigger={
        <WithUpdateSidebar>
          <HoverSVGIcon
            className={cn({ active: isOpen })}
            name="knowledgeBase"
            size={size}
            withTooltip={tooltipConfig}
          />
        </WithUpdateSidebar>
      }
      upward
    />
  )
}
